export const loanTypes = {
  immediate: 'immediate',
  refill: 'refill',
  simple: 'simple',
  topup: 'topup',
};
